<template>
  <v-card
    class="product-card rounded-lg px-0 px-md-2 d-flex flex-column w-100"
    color="sand"
    :style="cardStyles"
    v-bind="$attrs"
    v-on="$listeners"
    :ripple="{ class: `primary--text` }"
    elevation="0"
    @click="emitProductId"
  >
    <v-card-title class="text-title primary--text font-weight-bold pt-5 pb-1">
      {{ title }}
    </v-card-title>

    <v-card-text
      class="pt-1 d-flex flex-column justify-start justify-space-between card_text"
    >
      <v-row
        v-for="g in generals"
        :key="g.index"
        dense
        :class="!firstTabsCards && 'card-row'"
        class="pt-1"
      >
        <v-col cols="6" class="d-flex flex-column justify-center">
          <span class="text-label font-weight-medium primary--text">
            {{ g.label.data }}
          </span>
        </v-col>
        <v-col cols="6" class="text-right d-flex flex-column justify-center">
          <span
            class="text-currency font-weight-medium primary--text"
            :class="parseInt(g.value.data, 10) >= 0 ? '' : 'error--text'"
          >
            {{ g.value.data }}
          </span>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: null
    },
    generals: {
      type: [Array, Object],
      default: null
    },
    productReferenced: {
      type: [Array, Object, Number],
      default: null
    },
    firstTabsCards: {
      type: [Boolean]
    },
    height: {
      type: [String, Number],
      default: 200
    }
  },
  computed: {
    cardStyles() {
      return this.firstTabsCards ? 'height: 250px;' : 'height: 200px;'
    }
  },
  methods: {
    emitProductId() {
      this.$emit('emitProductId', this.productReferenced.id)
    }
  }
}
</script>

<style lang="sass" scoped>
.product-card
  height: 250px
  width: 100%
  min-width: 320px

  &.v-card--link::before
    background: white

  //&.active
    border: 1px solid #0077FF65
    //&.v-sheet.v-card:not(.v-sheet--outlined)
      box-shadow: 0px 6px 10px #0077FF65

  //&.v-sheet.v-card:not(.v-sheet--outlined)
    border: 1px solid #00000019
    //box-shadow: 0px 6px 10px #00000019

  //font size 14 en body
  .text-title
    font-size: 1.429rem

  .text-label
    font-size: 12px

  .text-currency
    font-size: 12px

@media only screen and (max-width: 768px)
  .product-card
    width: 300px
    height: 100%
    min-height: 170px

  .text-title
    font-size: 1.1rem

  .text-label
    font-size: 0.85rem

  .text-currency
    font-size: 0.85rem
</style>
